import { render } from "./BlocoNoticiasDestaque.vue?vue&type=template&id=2c20b0ed&scoped=true"
import script from "./BlocoNoticiasDestaque.vue?vue&type=script&lang=js"
export * from "./BlocoNoticiasDestaque.vue?vue&type=script&lang=js"

import "./BlocoNoticiasDestaque.vue?vue&type=style&index=0&id=2c20b0ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c20b0ed"]])

export default __exports__